import React from 'react';
import AdSlot from '../advertisement/AdSlot';

/**
 * Partner ad band right under the ticker tape, from GET /api/ads. Renders
 * nothing unless the slot (or its fallback) is configured and enabled.
 *
 * slotId: one slot id, or several in order of preference
 */
export const OfferStrip = ({ slotId }) => (
  <AdSlot slotId={slotId} container={{ className: 'pt-1', maxWidthClass: 'max-w-[1680px]' }} />
);

export default OfferStrip;
